import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import Layout from 'components/Layout';
import hasAuthToken from 'lib/hasAuthToken';

const PrivacyPage = () => {
  const { t } = useTranslation();

  return (
    <Layout title={t('privacy.pageTitle')}>
      <div className="o-retain o-retain--lap u-margin-top-huge u-margin-bottom-huge">
        <h1>{t('privacy.pageHeading')}</h1>
        <p>
          <strong>Privacy / Verwerkingsovereenkomst&nbsp;</strong>
        </p>
        <p>
          Dit is de{' '}
          <strong>Privacy / Verwerkingsovereenkomst / AVG / GDPR </strong>van
          deBanenSite.nl B.V. ("deBanenSite.nl"). deBanenSite.nl&nbsp;is de
          verantwoordelijke voor de verwerking van persoonsgegevens die worden
          verzameld via deze website. Bij solliciteren worden uw gegevens ook
          doorgestuurd naar de desbetreffende werkgever / intermediair waar u
          solliciteert. Elk bedrijf is er zelf verantwoordelijk voor om te
          voldoen aan de geldige wetgeving.
        </p>
        <p>
          Bij gebruik van deBanenSite.nl gaat u akkoord met de geldende
          voorwaarden van deBanenSite.nl B.V.
        </p>
        <p>
          Bij deBanenSite.nl nemen we de privacy van onze gebruikers serieus. We
          voldoen aan alle geldende regels voor gegevensbescherming en u kunt
          erop rekenen dat we er alles aan doen om de veranderingen door te
          voeren die nodig zijn, nu en in de toekomst, om ons te houden aan de
          geldige wetgeving. Die omvat verschillende componenten en aspecten,
          zoals:
        </p>
        <ol>
          <li>Informatie op een eerlijke manier verkrijgen en verwerken;</li>
          <li>Bijhouden van informatie voor een of meer specifieke doelen;</li>
          <li>
            Verwerken van gegevens op manieren die verenigbaar zijn met de
            doelen;
          </li>
          <li>Veilig opslaan;</li>
          <li>Gerechtvaardigd belang;</li>
          <li>Recht om vergeten te worden;</li>
          <li>Inzicht in persoonlijke gegevens.</li>
        </ol>
        <p>
          <strong>Wie is deBanenSite.nl ?&nbsp;</strong>
        </p>
        <p>
          deBanenSite.nl is een Nederlandse onderneming die een online
          (databank) banensite aanbiedt en als zodanig Werkzoekenden en
          Werkgevers met elkaar in contact brengt. deBanenSite.nl B.V. is
          gevestigd in Alkmaar aan de Toermalijnstraat 12D en staat ingeschreven
          in het Handelsregister van de Kamer van Koophandel onder nummer
          37069600. deBanenSite.nl is geregisteerd bij College bescherming
          persoonsgegevens: 1397601
        </p>
        <p>
          <strong>Welke informatie wordt verzameld en verwerkt?</strong>
        </p>
        <p>
          <strong>
            <em>Sollicitatie</em>
          </strong>
        </p>
        <p>
          De sollicitatiegegevens worden bewaard. Bij het solliciteren via
          deBanenSite.nl verwerkt deBanenSite.nl de ingevoerde gegevens (zoals
          NAW - gegevens) evenals de meegestuurde gegevens.
        </p>
        <p>
          De opgeslagen informatie wordt zo toegankelijk voor werkgevers en / of
          intermediairs die de sites bezoeken op zoek naar geschikt personeel.
          Voor extra zichtbaarheid kunnen de gegevens ook beschikbaar worden
          gesteld (geëxporteerd) aan derden.
        </p>
        <p>
          Door het ter beschikking stellen van de gegevens stellen wij deze
          werkgevers en / of intermediairs en / of derden in staat om te kijken
          of zij een geschikte baan hebben en of zij contact kunnen opnemen.
        </p>
        <p>
          deBanenSite.nl is niet verantwoordelijk voor de naleving van privacy
          wetgeving door werkgevers en / of intermediairs en / of derden.
        </p>
        <p>
          deBanenSite.nl is zodanig beveiligd dat er zonder inlogcodes niet
          ingelogd kan worden. De beveiliging is te herkennen aan onze SSL EV
          certificaat, hierbij ziet de gebruiker in de browser de vermelding
          'https' in de URL (veilig), een gesloten slotje en de organisatienaam
          zoals in het KVK register is vermeld.
        </p>
        <p>
          <strong>
            <em>Account</em>
          </strong>
        </p>
        <p>
          Na sollicitatie wordt er een account aangemaakt om optimaal gebruik te
          kunnen maken van de dienst deBanenSite.nl. Wanneer uw account is
          gecreëerd, wordt aan u gevraagd bepaalde informatie over uzelf te
          verstrekken. Niet alle gegevens moeten verplicht worden verstrekt. De
          verstrekte informatie kan altijd in het Account worden aangepast. Door
          het account waarborgen wij de statistieken van wie wanneer uw gegevens
          bekijkt. Binnen het account kunt u ook direct alle gegevens
          verwijderen onder "Mijn privacy".
        </p>
        <p>
          deBanenSite.nl&nbsp;publiceert gegevens die u in uw account hebt
          opgenomen op de website. Deze gegevens zijn toegankelijk voor
          (ingelogde) bezoekers van deBanenSite.nl. Indien u niet wilt dat deze
          gegevens zichtbaar zijn, dan kunt u de invulvelden in uw account leeg
          laten.
        </p>
        <p>
          <strong>Voor welke doeleinden wordt u informatie gebruikt?</strong>
          &nbsp;
        </p>
        <p>
          deBanenSite.nl heeft een gerechtvaardigd belang om uw persoonsgegevens
          te verzamelen en voor de volgende doeleinden te gebruiken:
        </p>
        <ul>
          <li>Solliciteren bij werkgevers / intermediairs;</li>
          <li>
            Gegevens beschikbaar stellen aan werkgevers / intermediairs die
            opzoek zijn naar geschikt personeel;
          </li>
          <li>Mogelijkheid bieden een account aan te maken;</li>
          <li>Account beheren en inzicht krijgen in gebruik van uw data</li>
          <li>
            Diensten van deBanenSite.nl zo goed mogelijk aan u te kunnen
            verlenen;
          </li>
          <li>Informatie te zenden over de werking van de dienst;</li>
          <li>
            Informatie te zenden omtrent de eigen, gelijksoortige diensten, van
            deBanenSite.nl;
          </li>
          <li>
            Informatie te verstrekken aan derden op basis van wettelijke
            verplichtingen.&nbsp;
          </li>
        </ul>
        <p>
          deBanenSite.nl is een Nederlandse onderneming die een online
          (databank) banensite aanbiedt en als zodanig Werkzoekenden en
          Werkgevers met elkaar in contact brengt. Uw gegevens staan opgeslagen
          op Nederlandse servers. Beschikt u over een account dan worden de
          ingevoerde gegevens zichtbaar voor werkgevers / intermediairs die
          (beveiligd) toegang hebben tot deBanenSite.nl.
        </p>
        <p>
          <strong>Beveiliging en bewaartermijn</strong>
        </p>
        <p>
          De persoonsgegevens die via deBanenSite.nl worden verzameld zijn
          beveiligd.&nbsp;deBanenSite.nl beschikt over een Extended SSL EV
          certificaat en een versleutelde verbinding. Uw gegevens staan op een
          Nederlandse server (Proserve B.V.). deBanenSite.nl&nbsp;bewaart uw
          (persoons-)gegevens zo lang uw account of profiel in stand blijft of
          zo lang als de wet dat voorschrijft.&nbsp;deBanenSite.nl&nbsp;mag de
          persoonsgegevens langer bewaren indien er omstandigheden zijn die
          daartoe aanleiding geven.
        </p>
        <p>
          <strong>Cookies</strong>
        </p>
        <p>
          deBanenSite.nl&nbsp;maakt gebruik van functionele en analytische
          cookies via Google Analytics, een webanalyse-service die wordt
          aangeboden door Google Inc. (“Google”). Google Analytics maakt gebruik
          van cookies om deBanenSite.nl&nbsp;te helpen analyseren hoe gebruikers
          de Website gebruiken. De door de cookie gegenereerde informatie over
          uw gebruik van de website (met inbegrip van uw IP-adres) wordt
          overgebracht naar en door Google opgeslagen op servers in de Verenigde
          Staten. Google gebruikt deze informatie om bij te houden hoe de
          website gebruikt wordt, rapporten over de website-activiteit op te
          stellen voor deBanenSite.nl&nbsp;en andere diensten aan te bieden met
          betrekking tot website-activiteit en internetgebruik. Google mag deze
          informatie aan derden verschaffen indien Google hiertoe wettelijk
          wordt verplicht, of voor zover deze derden de informatie namens Google
          verwerken. Google zal uw IP-adres niet combineren met andere gegevens
          waarover Google beschikt.
        </p>
        <p>
          <strong>Tracking-cookies</strong>
        </p>
        <p>
          Dit zijn cookies die binnen een domein of over verschillende domeinen
          gebruikt worden om surfgedrag van de bezoekers vast te leggen.
          Momenteel maakt deBanenSite.nl geen gebruik van tracking-cookies.
        </p>
        <p>
          <strong>Overige cookies&nbsp;</strong>
        </p>
        <p>
          deBanenSite.nl kan mediabestanden van websites van derden bevatten.
          Bij het afspelen van deze mediabestanden kunnen door deze derden
          cookies geplaatst worden. Verder biedt deze website de optie om
          bepaalde informatie te delen via sociale netwerken als Facebook.com,
          Whatsapp, LinkedIn.com of Google.com. Bij gebruik van deze
          functionaliteit kunnen door deze sociale netwerken cookies op uw
          computer geplaatst worden om bij te houden welke informatie gedeeld
          is.
        </p>
        <p>
          <strong>Blokkeren van cookies&nbsp;</strong>
        </p>
        <p>
          U kunt uw internet browser zo instellen dat u wordt gewaarschuwd als
          er een cookie wordt geplaatst. Ook kunt u het plaatsen van cookies
          volledig blokkeren. U kunt dan echter mogelijk niet van alle
          onderdelen van de website gebruikmaken.&nbsp;
        </p>
        <p>
          <strong>Verwijdering, inzage en correctie.</strong>
        </p>
        <p>
          U kunt uw gegevens inzien en zelf corrigeren of verwijderen binnen uw
          account.
        </p>
        <p>
          Indien u een account of een profiel heeft, kunt u dit voor het
          grootste deel zelf doen, bijvoorbeeld via "Mijn gegevens" of "Mijn
          privacy". In de gevallen dat dit op deze manier niet mogelijk is,
          stuurt u een e-mail met uw naam en contactgegevens/accountgegevens
          aan&nbsp;<a href="mailto:info@debanensite.nl">info@debanensite.nl</a>.
          In uw verzoek dient u zoveel mogelijk te specificeren op welke
          persoonsgegevens het verzoek ziet. Naar aanleiding van uw verzoek
          berichten we u over het verdere verloop van de procedure.
        </p>
        <p>
          deBanenSite.nl&nbsp;zal in beginsel binnen 5 werkdagen op een verzoek
          tot inzage- of correctieverzoek reageren. In geval van een verzoek tot
          verwijdering zal deBanenSite.nl&nbsp;de betreffende persoonsgegevens
          binnen 5 werkdagen verwijderen (wettelijk 4 weken), tenzij en voor
          zover de wet verplicht om de betreffende persoonsgegevens te bewaren
          of er (andere) dringende redenen zijn die zich tegen verwijdering
          verzetten.&nbsp;deBanenSite.nl&nbsp;stuurt u na uitvoering van een
          verzoek tot verwijdering een bevestigingsbericht.
          Indien&nbsp;deBanenSite.nl&nbsp;de betreffende persoonsgegevens
          (gedeeltelijk) niet heeft verwijderd, stuurt deBanenSite.nl&nbsp;de
          bezoeker een bericht waarin zij toelicht waarom niet (volledig) aan
          het verzoek kon worden voldaan.
        </p>
        <p>
          Indien deBanenSite.nl&nbsp;niet of niet volledig kan vaststellen op
          welke persoonsgegevens een verzoek tot inzage, correctie of
          verwijdering betrekking heeft, kan deBanenSite.nl&nbsp;de bezoeker
          vragen om zijn verzoek (nader) te
          specificeren.&nbsp;deBanenSite.nl&nbsp;schort de uitvoering van het
          verzoek op totdat de bezoeker deBanenSite.nl&nbsp;de (nadere)
          specificatie heeft verstrekt.
        </p>
        <p>
          <strong>Verwerkersovereenkomst</strong>
        </p>
        <p>
          1.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Deze Verwerkersovereenkomst
          regelt de Verwerking van Persoonsgegevens door Wederpartij in het
          kader van het gebruik van de deBanenSite.nl &amp; HR tool.
          <br />
          1.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; De aard en het doel van de
          Verwerking, wordt beschreven in bovenstaande privacy document.
          <br />
          1.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Wederpartij garandeert de
          toepassing van passende technische en organisatorische maatregelen,
          opdat de Verwerking aan de vereisten van de wetgeving voldoet en de
          bescherming van de rechten van de Betrokkene is gewaarborgd.
          <br />
          1.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Wederpartij garandeert te
          voldoen aan de vereisten van de toepasselijke wet- en regelgeving
          betreffende de verwerking van Persoonsgegevens
        </p>
        <p>
          <strong>Artikel 2. Inwerkingtreding en duur </strong>
        </p>
        <p>
          2.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Deze Verwerkersovereenkomst
          treedt in werking op het moment waarop partijen gebruik maken van
          diensten van deBanenSite.nl B.V.
          <br />
          2.2 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Deze Verwerkersovereenkomst eindigt
          nadat het “online” account van Wederpartij verwijderd is.
        </p>
        <p>
          <strong>Artikel 3. Omvang Verwerkingsbevoegdheid Wederpartij </strong>
        </p>
        <p>
          3.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Wederpartij Verwerkt de
          Persoonsgegevens uitsluitend op basis van gerechtvaardigd belang,
          behoudens afwijkende wettelijke voorschriften die op Wederpartij van
          toepassing zijn.
          <br />
          3.2&nbsp;&nbsp;&nbsp;&nbsp; Indien een instructie als bedoeld in het
          eerste lid naar het oordeel van Wederpartij in strijd is met een
          wettelijk voorschrift inzake gegevensbescherming, stelt hij
          deBanenSite.nl daarvan voorafgaand aan de verwerking in kennis, tenzij
          een wettelijk voorschrift deze kennisgeving verbiedt.
          <br />
          3.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Indien Wederpartij op grond
          van een wettelijke verplichting Persoonsgegevens dient te verstrekken,
          informeert hij deBanenSite.nl onmiddellijk, en zo mogelijk voorafgaand
          aan de verstrekking.
        </p>
        <p>
          <strong>Artikel 4. Beveiliging van de Verwerking</strong>
        </p>
        <p>
          4.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Partijen erkennen dat het
          waarborgen van een passend beveiligingsniveau voortdurend kan dwingen
          tot het treffen van aanvullende beveiligingsmaatregelen. Wederpartij
          waarborgt een op het risico afgestemd beveiligingsniveau.
          <br />
          4.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Indien en voor zover
          debanenSite.nl daarom uitdrukkelijk schriftelijk verzoekt, zal
          Wederpartij aanvullende maatregelen treffen met het oog op de
          beveiliging van de Persoonsgegevens.
          <br />
          4.3&nbsp; &nbsp; &nbsp; &nbsp;Wederpartij Verwerkt Persoonsgegevens
          niet buiten de Europese Unie, tenzij hij daarvoor uitdrukkelijk
          schriftelijk toestemming heeft verkregen van deBanenSite.nl en
          behoudens afwijkende wettelijke verplichtingen.
          <br />
          4.4&nbsp; &nbsp; &nbsp; &nbsp;Wederpartij informeert deBanenSite.nl
          zonder onredelijke vertraging zodra hij kennis heeft genomen van
          onrechtmatige Verwerkingen van Persoonsgegevens of inbreuken op
          beveiligingsmaatregelen zoals genoemd in het eerste lid.
          <br />
          4.5&nbsp; &nbsp; &nbsp; &nbsp;Wederpartij verleent deBanenSite.nl
          bijstand bij het doen nakomen van de verplichtingen uit hoofde van de
          Verordening en eventuele Wetgeving.
        </p>
        <p>
          <strong>
            Artikel 5. Geheimhouding door Personeel van Wederpartij
          </strong>
        </p>
        <p>
          5.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; De Persoonsgegevens hebben een
          vertrouwelijk karakter.
          <br />
          5.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Wederpartij toont op verzoek
          van deBanenSite.nl aan dat zijn Personeel zich ertoe heeft verbonden
          vertrouwelijkheid in acht te nemen.&nbsp;
        </p>
        <p>
          <strong>Artikel 6. Subverwerker</strong>
        </p>
        <p>
          Wanneer Wederpartij een andere verwerker inschakelt om ten behoeve van
          deBanenSite.nl verwerkingsactiviteiten te verrichten, worden aan deze
          andere verwerker bij een overeenkomst dezelfde verplichtingen inzake
          gegevensbescherming opgelegd als die welke in deze
          Verwerkersovereenkomst zijn opgenomen.
        </p>
        <p>
          <strong>Artikel 7. Bijstand vanwege rechten van Betrokkene</strong>
        </p>
        <p>
          Wederpartij verleent deBanenSite.nl bijstand bij het vervullen van
          diens plicht om verzoeken om uitoefening van de Verordening
          vastgestelde rechten van de Betrokkene te beantwoorden.
        </p>
        <p>
          <strong>Artikel 8. Inbreuk in verband met Persoonsgegevens</strong>
        </p>
        <p>
          8.1 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Wederpartij informeert
          deBanenSite.nl zonder onredelijke vertraging, zodra hij kennis heeft
          genomen van een Inbreuk in verband met Persoonsgegevens.
          <br />
          8.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Wederpartij informeert
          deBanenSite.nl ook na een melding op grond van het eerste lid over
          ontwikkelingen betreffende de Inbreuk in verband met Persoonsgegevens.
          <br />
          8.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Partijen dragen de door
          henzelf in verband met de melding aan de bevoegde toezichthoudende
          autoriteit en Betrokkene te maken kosten.
        </p>
        <p>
          <strong>Artikel 9. Teruggave Persoonsgegevens</strong>
        </p>
        <p>
          Na afloop van de Samenwerking draagt Wederpartij, naar gelang de keuze
          van deBanenSite.nl, zorg voor het terugbezorgen aan deBanenSite.nl of
          het wissen van alle Persoonsgegevens. Wederpartij verwijdert
          &nbsp;kopieën, behoudens afwijkende wettelijke voorschriften.
        </p>
        <p>
          deBanenSite.nl&nbsp;kan deze privacy, cookie policy en
          verwerkersovereenkomst eenzijdig wijzigen. Door gebruik te maken van
          deBanenSite.nl gaat u akkoord met de geldende voorwaarden, privacy,
          disclaimer, cookie en verwerkersovereenkomst.
        </p>
        <p>
          <em>
            <strong>Datum: 22 januari 2019.</strong>
          </em>
        </p>
      </div>
    </Layout>
  );
};

export async function getServerSideProps({ req, res, locale }) {
  if (!hasAuthToken(req)) {
    res.setHeader(
      'Cache-Control',
      'public, max-age=300, s-maxage=300, stale-while-revalidate=600'
    );
  }

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
}

export default PrivacyPage;
